import produce from 'immer';
import {
    GET_FARM_ORGANIZATION_REQUEST, GET_FARM_ORGANIZATION, GET_ORGANIZATION_REQUEST, GET_ORGANIZATION,
    GET_ORGANIZATION_CATEGORY_REQUEST, GET_ORGANIZATION_CATEGORY
} from '../constants/action-types';
import logo from '../../assets/images/acuitus-ag-logo.png';
import { palette } from '../theme/palette';
import {
    ACTION_COLOR_KEYS, BACKGROUND_COLOR_KEYS, COMMON_COLOR_KEYS, GREY_COLOR_KEYS, TEXT_COLOR_KEYS,
    VARIANT_COLOR_KEYS
} from '../constants';

const initialState = {
    isRequesting: true,
    isOrganizationRequesting: true,
    organizationList: [],
    organizationName: "",
    organizationTypeId: "",
    organizationId: "",
    themeId: null,
    theme: { ...palette },
    uiConfig: {
        logoUrl: logo,
        isLogoVisible: true,
        isOrganizationVisible: false,
        isFarmVisible: true,
        organizationFontSize: '1.5rem',
        organizationFontFamily: `inherit`,
        organizationFontWeight: '500'
    }

}

export default (state = initialState, action) => {
    switch (action.type) {

        case GET_ORGANIZATION_REQUEST:
            state = produce(state, s => {
                s.isOrganizationRequesting = true;
            });
            break;

        case GET_ORGANIZATION:
            state = produce(state, s => {
                s.isOrganizationRequesting = false;
                s.organizationList = action.payload;
            });
            break;

        case GET_FARM_ORGANIZATION_REQUEST:
            state = { ...state, isRequesting: true };
            break;

        case GET_ORGANIZATION_CATEGORY_REQUEST:
            state = produce(state, s => {
                s.isOrganizationCategoryRequesting = true;
            });
            break;

        case GET_ORGANIZATION_CATEGORY:
            state = produce(state, s => {
                s.isOrganizationCategoryRequesting = false;
                s.organizationCategory = action.payload;
            });
            break;

        case GET_FARM_ORGANIZATION:
            if (!action.payload) {
                state = { ...state, isRequesting: false };
                break;
            }
            const { theme_config, ...rest } = action.payload;
            const theme = theme_config ? parseTheme(theme_config) : initialState.theme;
            state = { ...state, theme, ...parseOrganization(rest), isRequesting: false };
            break;
        default:
            break;
    }
    return state;
}

const parseOrganization = (organization) => {
    const { organization_name, organization_uuid, organization_type_id, theme_id, ui_config } = organization;
    return {
        organizationName: organization_name,
        organizationId: organization_uuid,
        organizationTypeId: organization_type_id,
        themeId: theme_id,
        uiConfig: parseUiConfig(ui_config)
    }
}

const parseUiConfig = (uiConfig) => {
    const { logoUrl: initialLogo, isLogoVisible: initLogoVisible, isOrganizationVisible: initOrgVisible, isFarmVisible: initFarmVisible, organizationFontFamily: iFontFamily, organizationFontSize: iFontSize, organizationFontWeight: iFontWeight } = initialState.uiConfig;
    uiConfig = uiConfig || {};
    return {
        logoUrl: uiConfig.logoUrl || initialLogo,
        isLogoVisible: uiConfig.isLogoVisible === undefined ? initLogoVisible : uiConfig.isLogoVisible,
        isOrganizationVisible: uiConfig.isOrganizationVisible === undefined ? initOrgVisible : uiConfig.isOrganizationVisible,
        isFarmVisible: uiConfig.isFarmVisible === undefined ? initFarmVisible : uiConfig.isFarmVisible,
        organizationFontSize: uiConfig.organizationFontSize || iFontSize,
        organizationFontFamily: uiConfig.organizationFontFamily || iFontFamily,
        organizationFontWeight: uiConfig.organizationFontWeight || iFontWeight
    }
}


const copyObject = (keyArr, curr, init) =>
    Array.isArray(keyArr)
        ? keyArr.reduce((acc, key) => {
            acc[key] = curr[key] || init[key];
            return acc;
        }, {}) : {};

const parseTheme = (theme) => {
    const { common = {}, primary = {}, secondary = {}, info = {}, success = {}, warning = {}, error = {}, grey = {}, divider = {}, action = {}, text = {}, background = {} } = theme;
    const { common: c, primary: p, secondary: s, info: i, success: su, warning: w, error: e, grey: g, divider: d, action: a, text: t, background: b } = initialState.theme;

    return {
        common: { ...copyObject(COMMON_COLOR_KEYS, common, c) },
        primary: { ...copyObject(VARIANT_COLOR_KEYS, primary, p) },
        secondary: { ...copyObject(VARIANT_COLOR_KEYS, secondary, s) },
        info: { ...copyObject(VARIANT_COLOR_KEYS, info, i) },
        success: { ...copyObject(VARIANT_COLOR_KEYS, success, su) },
        warning: { ...copyObject(VARIANT_COLOR_KEYS, warning, w) },
        error: { ...copyObject(VARIANT_COLOR_KEYS, error, e) },
        grey: { ...copyObject(GREY_COLOR_KEYS, grey, g) },
        divider: divider || d,
        action: { ...copyObject(ACTION_COLOR_KEYS, action, a) },
        text: { ...copyObject(TEXT_COLOR_KEYS, text, t) },
        background: { ...copyObject(BACKGROUND_COLOR_KEYS, background, b) }
    }
}
